import * as fromDatatype from '../datatype-library/index';

export interface bl_pgw_payment_aggregator_RowInterface {
  code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_name: fromDatatype.VarcharDatatypeInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  country_name: fromDatatype.VarcharDatatypeInterface;
  company_name: fromDatatype.VarcharDatatypeInterface;
  payment_channel_name: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class bl_pgw_payment_aggregator_RowClass implements bl_pgw_payment_aggregator_RowInterface {
  code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_name: fromDatatype.VarcharDatatypeInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  country_name: fromDatatype.VarcharDatatypeInterface;
  company_name: fromDatatype.VarcharDatatypeInterface;
  payment_channel_name: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;

}
